import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { TabletIdentifierService } from '@app-services/tablet-identifier/tablet-identifier.service'
import { TabletsService } from '@app-services/tablets/tablets.service'
import { TabletStatusEnum } from '../generated/graphql'

export const isConfiguredGuard: CanActivateFn = async () => {
    const tabletsService = inject(TabletsService)
    const tabletIdentifierService = inject(TabletIdentifierService)
    const router = inject(Router)


    const identifier = tabletIdentifierService.getIdentifier()

    if (! identifier) {
        return router.createUrlTree(['/onboarding'])
    }

    const status = await tabletsService.getTabletStatus(identifier)


    if (status === TabletStatusEnum.Unregistered) {
        return router.createUrlTree(['/onboarding'])
    }

    return status === TabletStatusEnum.Registered
}
